export const EpiqAdmin = 'Epiq Admin';
export const EpiqProjectManager = 'Epiq Project Manager';
export const EpiqTechSupport = 'Epiq Tech Support';
export const EpiqTemplateAdmin = 'Epiq Template Admin';	 	 	 	 
export const EpiqUser = 'Epiq User';  	 	 	 	 
export const Nominee = 'Nominee';
export const BusinessAnalyst = "Business Analyst";
